import { render, staticRenderFns } from "./commodityModel.vue?vue&type=template&id=7eaf1ef8&scoped=true&"
import script from "./commodityModel.vue?vue&type=script&lang=js&"
export * from "./commodityModel.vue?vue&type=script&lang=js&"
import style0 from "./commodityModel.vue?vue&type=style&index=0&id=7eaf1ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaf1ef8",
  null
  
)

export default component.exports